import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import AgilysysLogo from '../components/AgilysysLogo';
import { ResidenceIcon, CommonAreasIcon, PoolsideIcon } from '../components/AreaIcons';
import greenTouchIcon from '../assets/green-touch-icon.gif';

const ResidentialPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page splash2 residentialPage">
      <Header />
      <div className="page-header">Residential Building</div>

      <div className="text-blocks">
        <div className="std-text">
          {"Create a sense of home for residents by empowering them with flexible meal transaction options."}
        </div>
        <div className="std-text">
          {"From staff-operated enterprise class point-of-sale systems to self-service kiosks and mobile ordering, enhance resident and staff engagement in your community with world-class hospitality technology solutions."}
        </div>
      </div>

      <div className="tap">
        <img
          src={greenTouchIcon}
          alt="Tap to explore"
        />
        <div className="tap-prompt">{"Tap on each section of the map\nTo drill into the details"}</div>
      </div>

      <div className="logo" onClick={() => navigate('/aboutus/agilysys')}>
        <AgilysysLogo />
      </div>

      <div className="residential-map">
        <div className="residence">
          <ResidenceIcon onClick={() => navigate('residence', { relative: 'path' })} />
        </div>
        <div className="common">
          <CommonAreasIcon onClick={() => navigate('common', { relative: 'path' })} />
        </div>
        <div className="pool">
          <PoolsideIcon onClick={() => navigate('pool', { relative: 'path' })} />
        </div>
      </div>
    </div>
  );
};

export default ResidentialPage;
